import React from 'react';
import styled from 'styled-components';
import AlertTriangleIcon from '../../../../../generic/icons/IconLib/AlertTriangleIcon';

type DisclaimerProps = {
  text?: string;
  children?: React.ReactNode;
};

const Disclaimer = ({ text, children }: DisclaimerProps) => {
  const content = children || text;

  if (!content) return null;

  return (
    <Wrapper>
      <TextWrapper>
        {typeof content === 'string' ? <Text>{content}</Text> : content}
      </TextWrapper>
      <IconWrapper>
        <ExclamationIcon>
          <AlertTriangleIcon />
        </ExclamationIcon>
      </IconWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 0.75em;
  padding: 0.875em 1em;
  background: linear-gradient(135deg, #fff9e6 0%, #fff3cd 100%);
  border: 1px solid rgba(255, 193, 7, 0.3);
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(255, 193, 7, 0.1);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    box-shadow: 0 3px 6px rgba(255, 193, 7, 0.15);
    border-color: rgba(255, 193, 7, 0.4);
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 0.125em;
`;

const ExclamationIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5em;
  height: 1.5em;
  color: #ff9800;
  font-size: 1.2em;

  svg {
    display: block;
    width: 1.2em;
    height: 1.2em;
  }
`;

const TextWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  min-height: 1.5em;
  justify-content: flex-end;
`;

const Text = styled.p`
  margin: 0;
  padding: 0;
  font-size: 0.9em;
  font-weight: 500;
  color: #856404;
  line-height: 1.5;
  font-family: 'Assistant', sans-serif;
  direction: rtl;
  text-align: right;
`;

export default Disclaimer;

